import DOMPurify from 'dompurify';

export const parseFull = (html) => {
  const goDeep = (node, level) => {
    if (level > 50) {
      return null;
    }

    const { nodeName, nodeValue = '' } = node;

    if (nodeName === '#text') {
      return {
        nodeName, nodeValue,
      };
    }

    const children = Array.from(node.childNodes)
      .map((child) => goDeep(child, level + 1));

    const attrs = {};

    if (node.hasAttributes()) {
      for (let i = 0; i < node.attributes.length; i += 1) {
        attrs[node.attributes[i].name] = node.attributes[i].value;
      }
    }

    if (nodeName === 'A') {
      attrs.target = '_blank';
      attrs.rel = 'noopener noreferrer nofollow';
    }

    return {
      nodeName,
      attrs,
      children,
    };
  };

  return {
    nodes: Array.from(DOMPurify.sanitize(html, { RETURN_DOM_FRAGMENT: true }).childNodes)
      .map((node) => goDeep(node, 1)),
  };
};
